var $beee3b800889f449$exports = {};
$beee3b800889f449$exports = {
    "clear": `Cancella`,
    "invalid": `(non valido)`,
    "loading": `Caricamento in corso...`,
    "noResults": `Nessun risultato`,
    "valid": `(valido)`
};


export {$beee3b800889f449$exports as default};
//# sourceMappingURL=it-IT.module.js.map
